import { Mic } from "lucide-react";

const LINKS = [
  ["How it works", "#how"],
  ["For students", "#use-cases"],
  ["Pricing", "#pricing"],
  ["FAQ", "#faq"],
];

export const Logo = () => (
  <a href="/" data-testid="nav-logo" className="flex items-center gap-2">
    <span className="grid h-8 w-8 place-items-center rounded-full bg-cyan text-black">
      <Mic className="h-4 w-4" />
    </span>
    <span className="font-display text-lg font-semibold tracking-tight">
      Tilla<span className="text-pink">'</span> <span className="font-normal text-muted-foreground">voice notes</span>
    </span>
  </a>
);

export const Navbar = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-background/70 backdrop-blur-xl">
    <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-10">
      <Logo />
      <div className="hidden items-center gap-8 md:flex">
        {LINKS.map(([label, href]) => (
          <a key={href} href={href} data-testid={`nav-link-${href.slice(1)}`} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
            {label}
          </a>
        ))}
      </div>
      <a href="#signup" data-testid="nav-cta-button" className="rounded-full border border-cyan/50 px-4 py-2 text-sm font-semibold text-cyan transition-colors hover:bg-cyan hover:text-black">
        Get early access
      </a>
    </nav>
  </header>
);
